export default "__VITE_ASSET__DmMiFPdy__"